import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ImgContainer = styled.div`
  height: 80px;
  width: 80px;
  position: relative;
  margin: auto;
`;

export const Rating = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  line-height: 26px;
  margin: 16px 0 0;
`;

export const RatingContainer = styled.div<{
  active: boolean;
}>`
  cursor: pointer;
  padding: 16px;
  border: 2px solid transparent;
  border-radius: 12px;
  flex: 1;
  ${({ active, theme }) =>
    active &&
    `
    border-color: ${theme.colors.brand[500]};
    background-color: #ECF6FF;
  `}
`;
